<template>
  <v-card light class="elevation-2">
    <v-toolbar dark elevation="0" color="error">
      <v-toolbar-title>{{ $t("TITLE") }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <p v-for="(paragraph, index) in paragraphs" :key="index" v-html="paragraph"></p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ErrorMessageSDM404',
  props: {
    error: {
      type: Error,
      default: null
    }
  },
  computed: {
    errorMessage () {
      const key = `ERROR_MESSAGES.${this.error.message.replaceAll(' ', '_').toUpperCase()}`
      const msg = this.$t(key)
      return msg !== key ? msg : this.error.message
    },
    paragraphs () {
      const message = this.$t('MESSAGE', { errorMessage: this.errorMessage })
      const paragraphs = message.split('\n')
      return paragraphs
    }
  }
}
</script>

<i18n>
{
  "fr": {
    "TITLE": "Information manquantes...",
    "MESSAGE": "<b>Nous somme dans l'incapacité de charger votre profil.</b>\n{errorMessage}",
    "ERROR_MESSAGES": {
      "MISSING_COMPANY_NAME": "<b>Si votre compte vient d'être créé; attendre quelques minutes et essayez de nouveau.</b>\n<b>Communiquez avec le support CPU si la situation persiste.</b>",
      "CONTACT_NOT_FOUND": "<b>Profile absent dans le service.</b>\n<b>Communiquez avec le support CPU pour remédier à la situation.</b>"
    }
  },
  "en": {
    "TITLE": "Missing information...",
    "MESSAGE": "<b>We are unable to load profile.</b>\n{errorMessage}",
    "ERROR_MESSAGES": {
      "MISSING_COMPANY_NAME": "<b>If your account has just been created; wait a few minutes and try again.</b>\n<b>Contact CPU Support if the situation persists.</b>",
      "CONTACT_NOT_FOUND": "<b>Profile missing in the service.</b>\n<b>Contact CPU support to resolve the situation.</b>"
    }
  }
}
</i18n>
